import { studentProfileAtom } from '@openeducation/oe-it-jotai-atoms';
import { useEnvironmentContext } from '@openeducation/oe-it-providers';
import { AuditServiceService } from '@openeducation/oe-it-services';
import { AuditServicePayload } from '@openeducation/oe-it-shared-types';
import { useAtomValue } from 'jotai';
import React from 'react';

export function useAuditService() {
  const { environment } = useEnvironmentContext();
  const studentProfile = useAtomValue(studentProfileAtom);

  const saveAudit = React.useCallback(
    (
      payload: Pick<
        AuditServicePayload,
        | 'action'
        | 'activityType'
        | 'category'
        | 'detail'
        | 'groupId'
        | 'itemId'
        | 'subGroupId'
        | 'value'
      >
    ) => {
      if (!studentProfile) {
        return;
      }
      const _payload = {
        contactId: studentProfile?.contactId,
        languageCode: studentProfile?.preferredLang,
        levelId: studentProfile?.workingLevelId.toString(),
        organization: 'Open English',
        ...payload,
      } as AuditServicePayload;

      AuditServiceService.postAuditService(environment, _payload);
    },
    [environment, studentProfile]
  );

  return {
    saveAudit,
  };
}
